import { destroyCache } from "./destroyCache";

export async function hardReset() {
  // 1. Cache API: todas as caches (precache + áudios por rádio)
  await destroyCache("", "DESTROY_ALL_CACHE");

  // 2. localStorage e sessionStorage
  localStorage.clear();
  sessionStorage.clear();

  // 3. IndexedDB (workbox usa IDB internamente)
  const databases = await indexedDB.databases?.();
  if (databases) {
    await Promise.all(databases.map((db) => db.name && indexedDB.deleteDatabase(db.name)));
  }

  // 4. Reload forçado sem cache
  window.location.reload();
}
